import DsButton from "@components/services/DsButton";

interface CtaBlockProps {
  title: string;
  description: string;
  primaryCta: {
    label: string;
    href: string;
  };
  secondaryCta?: {
    label: string;
    href: string;
    target?: string;
    rel?: string;
  };
}

export default function CtaBlock({
  title,
  description,
  primaryCta,
  secondaryCta,
}: CtaBlockProps) {
  return (
    <div className="cta-block">
      <h3>{title}</h3>
      <p>{description}</p>
      <div className="cta-actions">
        <DsButton href={primaryCta.href} label={primaryCta.label} variant="primary" />
        {secondaryCta ? (
          <DsButton
            href={secondaryCta.href}
            label={secondaryCta.label}
            variant="ghost-inverse"
            target={secondaryCta.target}
            rel={secondaryCta.rel}
          />
        ) : null}
      </div>
    </div>
  );
}
